import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { ListItemText } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Arbitrator from '../../components/Arbitrator';
import axios from 'axios';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import ChooseArbitratorDialog from './ChooseArbitratorDialog';
import ChooseArbitratorDialogRespondent from './ChooseArbitratorDialogRespondent';


const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent:'center',
        '@media (min-width: 1500px)': {
            height: '100vh'
          }
    },
    formControl: {
        marginLeft: theme.spacing.unit * 40,
        marginRight: theme.spacing.unit * 40,
        marginTop: theme.spacing.unit * 3,
    },
    group:{
        justifyContent:'stretch'
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        margin: theme.spacing.unit * 3,
    },
});

class ChooseArbitrator extends Component {

    state = {
      value: this.props.caseData.claimantArbitrator,
    //   value: '',
      open: false,
      open_: true,
      uniqueId: localStorage.getItem('token'),
      preRespondentUniqueId:this.props.claimantUniqueId,
      preRespondentArbitratorName:this.props.claimantArbitratorName
    };

    componentDidMount(){
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getCaseInfo`;
        let payload = {
            caseId: this.props.match.params.id,
        }
        axios.post(url, payload)
        .then((response) => {
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }

        })
        .catch((error) => {
            console.log(error);
        });

        setTimeout(()=>{
                this.props.getArbitrators(localStorage.getItem('token'));
        },2000)

        this.checkLanguage()
    }

    checkLanguage = function() {
        try{
          if (this.props.isLoading){
            setTimeout(()=>{this.checkLanguage()},100)
          }
          else{
            console.log('this caseData: '+JSON.stringify(this.props.caseData))
            var lang = localStorage.getItem('language');
            if (this.props !== undefined){
              if (this.props.caseData !== undefined){
                if (this.props.caseData.language !== undefined){
                  if (this.props.caseData.language == 'Chi'){
                    if (lang == 'en' || lang == undefined){
                      localStorage.setItem('language', 'cn');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                  else if (this.props.caseData.language == 'Eng'){
                    if (lang == 'cn' || lang == undefined){
                      localStorage.setItem('language', 'en');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                }
              }
            }
          }
        }catch(err){
          setTimeout(()=>{this.checkLanguage()},100)
        }
      }

    handleChange = event => {
        this.setState({
            value: event.target.value,
             open: true,
        });
    }

    setArbitrators = () => {
        console.log('setArbitrators2')
        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }
        this.props.setArbitrators(this.props.match.params.id, true, this.state.value, userType, this.props.handleComplete);
    }

    setArbitratorsIfRespondentAcceptClaimantArbitrator = () => {
        console.log('setArbitrators2')
        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }
            
        this.props.setArbitrators(this.props.match.params.id, true, this.props.caseData.claimantArbitrator, userType, this.props.handleComplete);
    }


    toggleOpen = () => {
        this.setState( (prevState) => ({
            open: !prevState.open,
        }) );
      }

      toggleOpen_ = () => {
        this.setState( (prevState) => ({
            open_: !prevState.open_,
        }) );
      }

    render(){
        const { classes, isLoading, arbitrators } = this.props;
        console.log('fm here')
        console.log(arbitrators)
        if(isLoading || (arbitrators == null) ){
            return(
                <CircularProgress size={50} thickness={3} className={classes.progress}/>
            );
        }
        else{
                var userType = '';
            if(this.props.claimantUniqueId == this.state.uniqueId){
                userType = 'claimant';
            }else if(this.props.respondentUniqueId == this.state.uniqueId){
                userType = 'respondent';
            }

            var lang = localStorage.getItem('language');
            console.log('chooseArbitrator arbitrators: userType: '+userType)
            // if (userType == 'respondent'){
                console.log('#arbitrators !==null : '+ (arbitrators !==null) )
                return(
                    <div className={classes.root}>
                    <Grid
                        container
                        spacing={8}
                        alignItems='center'
                        direction='column'
                        justify='center'
                        >
                        {userType !== 'respondent' && <Typography className={classes.formControl} style={{marginTop:'10px', fontWeight:'bold'}}>
                            {this.context.t('Please choose your arbitrator.')} 
                        </Typography>}
                        {userType !== 'respondent' &&
                        <Typography className={classes.formControl} style={{marginTop:'10px', color:'#B71C1C'}}>
                            {this.context.t('chooseArbitratorSubTitle')}<br></br>
                            {this.context.t('chooseArbitratorSubTitle2')}
                        </Typography>}
                        {userType !== 'respondent' && <ChooseArbitratorDialog open={this.state.open} toggleOpen={this.toggleOpen} setArbitrators={this.setArbitrators} claimantArbitratorName={this.props.claimantArbitratorName} respondentArbitratorName={this.props.respondentArbitratorName} claimantUniqueId={this.props.claimantUniqueId} respondentUniqueId={this.props.respondentUniqueId} uniqueId={this.state.uniqueId}  />} 

                        {userType == 'respondent' && <ChooseArbitratorDialogRespondent open={this.state.open_} toggleOpen={this.toggleOpen_} setArbitrators={this.setArbitratorsIfRespondentAcceptClaimantArbitrator} claimantArbitratorName={this.props.claimantArbitratorName} respondentArbitratorName={this.props.preRespondentArbitratorName} claimantUniqueId={this.props.claimantUniqueId} respondentUniqueId={this.state.preRespondentUniqueId} uniqueId={this.state.uniqueId}  />}
                        
                        <FormControl className={classes.formControl}>
                            <ChooseArbitratorDialog open={this.state.open} toggleOpen={this.toggleOpen} setArbitrators={this.setArbitrators} claimantArbitratorName={this.props.claimantArbitratorName} respondentArbitratorName={this.props.respondentArbitratorName} claimantUniqueId={this.props.claimantUniqueId} respondentUniqueId={this.props.respondentUniqueId} uniqueId={this.state.uniqueId} />
                            <RadioGroup
                                row
                                name='chooseArbitrator'
                                className={classes.group}
                                value={this.state.value}
                                onChange={this.handleChange}
                            >
                                {
                                arbitrators !==null && arbitrators.map((arbitrator, index) => (
                                    <FormControlLabel
                                        key={index}
                                        style={{marginLeft:'0px'}}
                                        value={arbitrator.arbitratorId}
                                        label={<Arbitrator 
                                                    firstName={arbitrator.firstname}
                                                    lastName={arbitrator.lastname}
                                                    occupation={arbitrator.occupation}
                                                    jurisdiction={arbitrator.jurisdiction}
                                                    expertise={arbitrator.expertise}
                                                    arbitratorId={arbitrator.arbitratorId}
                                                    firstName_chi={arbitrator.firstname_chi}
                                                    lastName_chi={arbitrator.lastname_chi}
                                                    occupation_chi={arbitrator.occupation_chi}
                                                    jurisdiction_chi={arbitrator.jurisdiction_chi}
                                                    expertise_chi={arbitrator.expertise_chi}
                                                    lang = {lang}
                                                    arbitrator={this.context.t('arbitrator')}
                                                    arbitratorProfile={this.context.t('arbitratorProfile')}
                                                    jurisdictions={ this.context.t('Jurisdiction') }
                                                    occupations={ this.context.t('Occupation') }
                                                />}
                                        control={<Radio style={{display:'none', width: 'auto'}} key={index} classes={{root: classes.radio, checked: classes.checked}}/>}
                                    />
                                ))
                                }
                            </RadioGroup>
                        
                        </FormControl>
                    
                    </Grid>
                    </div>
                )
            // }
            // else{
            //     return(
            //         <div className={classes.root}>
            //         <Grid
            //             container
            //             spacing={8}
            //             alignItems='center'
            //             direction='column'
            //             justify='center'
            //             >
            //                 <Typography style={{marginTop:'10px', fontWeight:'bold'}}>
            //                     {this.context.t('Please choose your arbitrator.')}
            //                 </Typography>
            //                 <Typography style={{marginTop:'10px', color:'#B71C1C'}}>
            //                     {this.context.t('chooseArbitratorSubTitle')}<br></br>
            //                     {this.context.t('chooseArbitratorSubTitle2')}
            //                 </Typography>
            //                 <ChooseArbitratorDialog open={this.state.open} toggleOpen={this.toggleOpen} setArbitrators={this.setArbitrators} claimantArbitratorName={this.props.claimantArbitratorName} respondentArbitratorName={this.props.respondentArbitratorName} claimantUniqueId={this.props.claimantUniqueId} respondentUniqueId={this.props.respondentUniqueId} uniqueId={this.state.uniqueId}  />
                        
            //             <FormControl component='fieldset' className={classes.formControl}>
            //                 <ChooseArbitratorDialog open={this.state.open} toggleOpen={this.toggleOpen} setArbitrators={this.setArbitrators} claimantArbitratorName={this.props.claimantArbitratorName} respondentArbitratorName={this.props.respondentArbitratorName} claimantUniqueId={this.props.claimantUniqueId} respondentUniqueId={this.props.respondentUniqueId} uniqueId={this.state.uniqueId}  />
            //                 <RadioGroup
            //                     name='chooseArbitrator'
            //                     className={classes.group}
            //                     value={this.state.value}
            //                     onChange={this.handleChange}
            //                 >
            //                         {
            //                             // <form >
            //                             // <input type="radio" name="paymentMethod" value="visa" />VISA <br></br><br></br>
                                        
            //                             arbitrators !==null && arbitrators.map((arbitrator, index) => (
            //                                 <FormControlLabel
            //                                     key={index}
            //                                     value={arbitrator.arbitratorId}
            //                                     label={<Arbitrator 
            //                                                 firstName={arbitrator.firstname}
            //                                                 lastName={arbitrator.lastname}
            //                                                 occupation={arbitrator.occupation}
            //                                                 jurisdiction={arbitrator.jurisdiction}
            //                                                 expertise={arbitrator.expertise}

            //                                                 firstName_chi={arbitrator.firstname_chi}
            //                                                 lastName_chi={arbitrator.lastname_chi}
            //                                                 occupation_chi={arbitrator.occupation_chi}
            //                                                 jurisdiction_chi={arbitrator.jurisdiction_chi}
            //                                                 expertise_chi={arbitrator.expertise_chi}
            //                                                 lang = {lang}

            //                                                 jurisdictions={ this.context.t('Jurisdiction') }
            //                                                 occupations={ this.context.t('Occupation') }
            //                                             />}
            //                                     control={<Radio key={index}
            //                                     classes={{root: classes.radio, checked: classes.checked}}/>}
            //                                 />
            //                             ))
            //                             // </form>
            //                         }
            //                 </RadioGroup>
            //             </FormControl>
            //         </Grid>
                    
            //         </div>
            //     )
            // }
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.arbitrator.loading,
        arbitrators: state.arbitrator.arbitrators,
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimantArbitratorName: state.caseInfo.claimantArbitratorName,
        respondentArbitratorName: state.caseInfo.respondentArbitratorName,
        lang: state.i18nState.lang,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getArbitrators: () => dispatch(actions.arbitrators()),
        getArbitratorsChi: () => dispatch(actions.arbitratorsChi()),
        setArbitrators: (caseId, firstTime, arbitratorId, type, handleComplete) => dispatch(actions.setArbitrators(caseId, firstTime, arbitratorId, type, handleComplete)),
    }
}

ChooseArbitrator.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ChooseArbitrator)));
